import styled, { css } from 'styled-components';
import { color, size, animation } from './helpers/variables';

export const FilterOption = styled.p`
  cursor: pointer;
  transition: opacity ${animation.transitionTime} ${animation.easing};
  display: flex;
  font-weight: normal;
  align-items: center;
  position: relative;
  margin: 2px 0;
  padding: 10px 0;
  font-size: 13px;

  &:before {
    content: '';
    display: inline-block;
    min-width: 13px;
    width: 13px;
    height: 13px;
    margin-right: 10px;
    background-color: ${color.lightGrey};
    border: solid 1px ${color.grey};
  }

  &:after {
    display: none;
  }

  &:hover {
    opacity: 0.8;
  }

  ${props =>
    props.active &&
    css`
      font-weight: 600;

      &:after {
        content: '';
        position: absolute;
        left: 4px;
        top: calc(50% - 3.5px);
        width: 7px;
        height: 7px;
        display: inline-block;
        background-color: ${color.primary};
      }
    `};

  ${props =>
    props.radioButton &&
    css`
      &:before {
        border-radius: 100%;
      }

      &:after {
        border-radius: 100%;
      }
    `};

  ${props =>
    props.backgroundColor &&
    css`
      &:before {
        background-color: ${props.backgroundColor};
      }

      &:after {
        background-color: ${color.white};
        width: 5px;
        height: 5px;
        border: solid 1px ${color.grey};
      }
    `};
  
  ${props =>
    Array.isArray(props.backgroundColor) &&
    props.backgroundColor.length === 2 &&
    css`
      &:before {
        background: linear-gradient(
          135deg,
          ${`${props.backgroundColor[0]}55`} 0%,
          ${`${props.backgroundColor[1]}55`} 100%
        );
      }
    `}
  
  ${props =>
    Array.isArray(props.backgroundColor) &&
    props.backgroundColor.length >= 3 &&
    css`
      &:before {
        background: linear-gradient(
          135deg,
          ${`${props.backgroundColor[0]}55`} 0%,
          ${`${props.backgroundColor[1]}55`} 50%,
          ${`${props.backgroundColor[2]}55`} 100%
        );
      }
    `}

  @media screen and (min-width: ${size.large}px) {
    font-size: 14px;

    &:before {
      min-width: 18px;
      width: 18px;
      height: 18px;
      margin-right: 17px;
    }

    &:after {
      left: 5px;
      top: calc(50% - 5px);
      width: 10px;
      height: 10px;
    }

    ${props =>
      props.backgroundColor &&
      css`
        &:after {
          background-color: ${color.white};
          width: 8px;
          height: 8px;
          border: solid 1px ${color.grey};
        }
      `};
  }
`;



// WEBPACK FOOTER //
// ./src/styles/FilterOption.js